import request from 'utils/request'
import { getStudyVersionID } from 'utils/studyConfigUtils'
import { instrumentV2Urls } from '../../../../Instruments/utils/instrumentV2Api'
import {
  deriveScheduledItemsFromArms,
  getChainDeployVisitIds,
  getInstrumentChainedStudyDay,
  getVisitChainedStudyDay,
} from '../utils/scheduleProjection'
import {
  getFirstScheduleContentDay,
  getGridDayCount,
  studyDurationFromListToDays,
} from '../utils/studyTimelineGridUtils'
import {
  RESET_STUDY_TIMELINE,
  SET_ABSOLUTE_START_DATE,
  SET_EXPECTED_STUDY_ID,
  SET_FILTER_BY_INSTRUMENT,
  SET_GRID_LOADED,
  SET_INCLUDE_VISIT_CYCLE,
  SET_INSTRUMENTS,
  SET_PARTICIPANT_VISITS,
  SET_PROJECTION_MODE,
  SET_PROJECTION_PARTICIPANT_ID,
  SET_SELECTED_ARM_ID,
  SET_SELECTED_DAY,
  SET_SELECTED_INSTRUMENT_ID,
  SET_STUDY_DURATION_FROM_LIST,
  SET_USE_ABSOLUTE_START_DATE,
  SET_VIEW_TYPE,
  SET_VISIT_SCHEDULES,
} from './studyTimelineReducer'

export {
  deriveScheduledItemsFromArms,
  getChainDeployVisitIds,
  getInstrumentChainedStudyDay,
  getVisitChainedStudyDay,
  getFirstScheduleContentDay,
  getGridDayCount,
  studyDurationFromListToDays,
}

const setViewType = payload => ({
  type: SET_VIEW_TYPE,
  payload,
})

const setSelectedArmId = payload => ({
  type: SET_SELECTED_ARM_ID,
  payload,
})

const setIncludeVisitCycle = payload => ({
  type: SET_INCLUDE_VISIT_CYCLE,
  payload,
})

const setUseAbsoluteStartDate = payload => ({
  type: SET_USE_ABSOLUTE_START_DATE,
  payload,
})

const setAbsoluteStartDate = payload => ({
  type: SET_ABSOLUTE_START_DATE,
  payload,
})

const setFilterByInstrument = payload => ({
  type: SET_FILTER_BY_INSTRUMENT,
  payload,
})

const setSelectedInstrumentId = payload => ({
  type: SET_SELECTED_INSTRUMENT_ID,
  payload,
})

const setSelectedDay = payload => ({
  type: SET_SELECTED_DAY,
  payload,
})

const setGridLoaded = payload => ({
  type: SET_GRID_LOADED,
  payload,
})

const setProjectionMode = payload => ({
  type: SET_PROJECTION_MODE,
  payload,
})

const setProjectionParticipantId = payload => ({
  type: SET_PROJECTION_PARTICIPANT_ID,
  payload,
})

const setParticipantVisits = payload => ({
  type: SET_PARTICIPANT_VISITS,
  payload,
})

const setExpectedStudyId = payload => ({
  type: SET_EXPECTED_STUDY_ID,
  payload,
})

export const setStudyDurationFromList = payload => ({
  type: SET_STUDY_DURATION_FROM_LIST,
  payload,
})

const setVisitSchedules = (data, studyId, studyDuration = null) => ({
  type: SET_VISIT_SCHEDULES,
  payload: { data, studyId, study_duration: studyDuration },
})

const setInstruments = (data, studyId) => ({
  type: SET_INSTRUMENTS,
  payload: { data, studyId },
})

const resetStudyTimeline = () => ({
  type: RESET_STUDY_TIMELINE,
})

const fetchVisitSchedules = studyId => (dispatch, getState) => {
  const { study, location } = getState()
  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const studyVersionID = getStudyVersionID(location)

  const getQueryParams = () => {
    if (hasStudyPromotion) {
      return `?study_version_id=${studyVersionID}`
    }
    return ''
  }

  const safeStudyId = studyId != null ? studyId : null
  dispatch(setExpectedStudyId(safeStudyId))
  const success = payload => {
    const data = payload.study_visit_schedule || []
    dispatch(setVisitSchedules(data, safeStudyId))
  }

  return dispatch(
    request({
      url: `/control/studies/${safeStudyId}/study_schedules${getQueryParams()}`,
      success,
      hasLoader: true,
      loadingKey: 'studyTimeline',
    }),
  )
}

const fetchInstruments = studyId => (dispatch, getState) => {
  const { study, location } = getState()
  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const studyVersionID = getStudyVersionID(location)

  const getQueryParams = () => {
    const params = ['include_compliance=false']
    if (hasStudyPromotion) {
      params.push(`study_version_id=${studyVersionID}`)
    }
    return `?${params.join('&')}`
  }

  const safeStudyId = studyId != null ? studyId : null
  const success = payload => {
    const instruments = payload?.results || []
    dispatch(setInstruments(instruments, safeStudyId))
  }

  return dispatch(
    request({
      url: instrumentV2Urls.list(safeStudyId, getQueryParams()),
      success,
      hasLoader: true,
      loadingKey: 'studyTimelineInstruments',
    }),
  )
}

const fetchParticipantVisitsForProjection = (studyId, participantId) => dispatch => {
  if (!studyId || !participantId) {
    dispatch(setParticipantVisits(null))
    return Promise.resolve()
  }
  return dispatch(
    request({
      url: `/control/studies/${studyId}/study_schedules_visits/participants/${participantId}`,
      success: payload => {
        const visits = Array.isArray(payload?.visits) ? payload.visits : Array.isArray(payload) ? payload : []
        dispatch(setParticipantVisits(visits))
      },
      hasLoader: false,
    }),
  )
}

export const actions = {
  setViewType,
  setSelectedArmId,
  setIncludeVisitCycle,
  setUseAbsoluteStartDate,
  setAbsoluteStartDate,
  setFilterByInstrument,
  setSelectedInstrumentId,
  setSelectedDay,
  setGridLoaded,
  setStudyDurationFromList,
  setProjectionMode,
  setProjectionParticipantId,
  fetchParticipantVisitsForProjection,
  fetchVisitSchedules,
  fetchInstruments,
  resetStudyTimeline,
}
